__webpack_require__.p = "/newslettery/nowy_kodiaq/";